import React, { useState } from 'react'
import { Produto } from '@/core/types/graphql'
import { OptionSelect } from '@/core/utils/types'
import { Select } from '@/core/components/select'
import { t } from '@lingui/core/macro'

interface Props {
  produtos: Produto[]
  filtroSelecionado: string[]
  setFiltroSelecionado: (value: string[]) => void
}

const FiltroProdutoPermissao = ({
  produtos,
  filtroSelecionado,
  setFiltroSelecionado
}: Props) => {
  const [inputSearch, setInputSearch] = useState('')

  const opcoesFiltro: OptionSelect[] = produtos.map(produto => ({
    label: produto.nome,
    value: String(produto.id)
  }))

  const handleFiltroChange = (selecionados: OptionSelect[]) => {
    const idsSelecionados = selecionados.map(opt => opt.value)
    setFiltroSelecionado(idsSelecionados)
  }

  return (
    <div style={{ width: '50%' }}>
      <Select
        isMultiSelect
        label={t`Filtrar produtos`}
        value={opcoesFiltro.filter(opt =>
          filtroSelecionado.includes(opt.value)
        )}
        options={opcoesFiltro}
        onSelect={handleFiltroChange}
        labelExtractor={(item: OptionSelect) => item.label}
        keyExtractor={(item: OptionSelect) => item.value}
        withSearch
        inputSearch={inputSearch}
        setInputSearch={setInputSearch}
      />
    </div>
  )
}

export default FiltroProdutoPermissao
